import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "../assets/css/userSettings.css";
import "../assets/images/userSettings";
import { settingsIcons } from "../assets/images/userSettings";
import { logout } from "../lib/api"; // appelle /auth/logout/ + clear tokens

export default function UserSettings() {
  const [activeTab, setActiveTab] = useState("profile");
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout(); // backend + suppression des tokens
    } catch (e) {
      console.error("Erreur lors de la déconnexion :", e);
    } finally {
      navigate("/login", { replace: true });
    }
  };

  const handleGoToUserManagement = () => {
    navigate("/settings/users");
  };

  return (
    <div className="page-container">
      <Sidebar />

      <div className="content-container">
        <div className="container-fluid">
          <div className="userGreeting">
            <span className="typoBlackStar">
              hello {/*<?php echo $session->get('User_FirstName'); ?>*/},
            </span>
            <br />
            <span>Lorem ipsum</span>
          </div>

          <div className="settings-container">
            {/* MENU GAUCHE */}
            <div className="settings-menu">
              <div className="menu-tabs">
                <button
                  className={`tab-links ${
                    activeTab === "profile" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("profile")}
                >
                  Mon profil
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "preferences" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("preferences")}
                >
                  Préférences
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "notifications" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("notifications")}
                >
                  Notifications
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "conditions" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("conditions")}
                >
                  Conditions
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "policy" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("policy")}
                >
                  Politique de confidentialité
                </button>
              </div>

              {/* BOUTONS EN BAS : Gestion utilisateurs + Logout */}
              <div className="menu-log">
                <button
                  className="delete"
                  // TODO : implémenter la suppression de compte plus tard
                  type="button"
                >
                  Supprimer le compte
                </button>

                {/* Bouton Gestion des utilisateurs → /settings/users */}
                <button
                  type="button"
                  className="log-out"
                  style={{ marginBottom: "0.5rem", backgroundColor: "#0d6efd" }}
                  onClick={handleGoToUserManagement}
                >
                  <p>Gestion des utilisateurs</p>
                  <img src={settingsIcons.edit} alt="Gestion des utilisateurs" />
                </button>

                {/* Bouton Déconnexion */}
                <button
                  className="log-out"
                  type="button"
                  onClick={handleLogout}
                >
                  <p>Déconnexion</p>
                  <img src={settingsIcons.exit} alt="Déconnexion" />
                </button>

                <div className="menu-footer">© 2024 Polyglowth</div>
              </div>
            </div>

            {/* CONTENU DROIT (tabs) */}
            <div className="settings-page">
              {activeTab === "profile" && (
                <div id="profile" className="tab-content tab-active">
                  <h3>Mon profil</h3>
                  <div className="user-profile">
                    <div className="profile-infos">
                      <img src={settingsIcons.profile} alt="Profil" />
                      <div className="profile-status">
                        <h4>Firstname</h4>
                        <h5 className="status">User group</h5>
                        <p className="member">Membre depuis X jours</p>
                      </div>
                    </div>
                    <div className="btn-edit">
                      <button>
                        éditer
                        <img src={settingsIcons.edit} alt="Editer" />
                      </button>
                    </div>
                  </div>
                  <div className="user-personal-datas">
                    <h4>Informations personnelles</h4>
                    <div className="datas-section">
                      <div className="datas-items">
                        <div className="mail">
                          <h5>Adresse mail</h5>
                          <p>Email</p>
                        </div>
                        <div className="nickname">
                          <h5>Pseudo</h5>
                          <p>Username</p>
                        </div>
                        <div className="password">
                          <h5>Mot de passe</h5>
                          <p>User password (hidden)</p>
                        </div>
                      </div>
                      <div className="btn-edit">
                        <button>
                          éditer
                          <img src={settingsIcons.edit} alt="Editer" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "preferences" && (
                <div id="preferences" className="tab-content tab-active">
                  <h3>Mes préférences</h3>
                  <div className="sound-effects pref-item">
                    <div className="content">
                      <img src={settingsIcons.sound} alt="Effets sonores" />
                      <div className="text">
                        <h5>Effets sonores</h5>
                        <p>
                          Activer les effets sonores durant les parties de jeux
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div className="music pref-item">
                    <div className="content">
                      <img src={settingsIcons.sound} alt="Musique" />
                      <div className="text">
                        <h5>Musique</h5>
                        <p>Activer la musique durant les parties de jeux</p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              )}

              {activeTab === "notifications" && (
                <div id="notifications" className="tab-content tab-active">
                  <h3>Notifications</h3>
                  <div className="training-reminders">
                    <div className="content">
                      <img src={settingsIcons.training} alt="Rappels" />
                      <div className="text">
                        <h5>Rappels d’entrainement</h5>
                        <p>
                          Activer les notifications de rappels d’entrainement
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div className="new-features">
                    <div className="content">
                      <img src={settingsIcons.newF} alt="Nouvelles fonctionnalités" />
                      <div className="text">
                        <h5>Annonce nouvelles fonctionnalités</h5>
                        <p>
                          Activer les pop-up d’annonce de nouvelles
                          fonctionnalités
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              )}

              {activeTab === "conditions" && (
                <div id="conditions" className="tab-content tab-active">
                  {/* … ton gros texte conditions/policy ici, inchangé … */}
                </div>
              )}

              {activeTab === "policy" && (
                <div id="policy" className="tab-content tab-active">
                  <h3>Politique de confidentialité</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
